import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const adminMeetingsList = (params = {}) => Http.get(`/admin/meetings${serialize(params)}`)
